// libs
import styled from "styled-components";
import { motion, Variants } from "framer-motion";
// components
import Icon from "./Icon";
import { Pill } from "./Pill";
// other
import { IconKey } from "../models/client";
import { easings } from "../styles/utils";

interface TooltipProps {
  expanded: boolean;
  icon: IconKey;
  children: React.ReactNode;
}

const TextBoundary = styled.div`
  position: absolute;
  top: 0;
  left: 32px;
  overflow: hidden;
`;

const TextContainer = styled(motion.div)`
  position: absolute;
  width: 100%;
  height: 64px;
  background-color: ${({ theme }) => theme.colors.hotPink};
  border-radius: 0 32px 32px 0;
  z-index: -1;
`;

const TextInner = styled(motion.div)`
  position: relative;
  z-index: 2;
  line-height: 64px;
  padding: 0 24px;
`;

const variants: Variants = {
  hidden: {
    x: "-100%",
    transition: { duration: 0.4, delay: 0.2, ease: easings.easeOutCubic },
  },
  expanded: {
    x: 0,
    transition: { duration: 0.4, ease: easings.easeOutCubic },
  },
};

const textVariants: Variants = {
  hidden: {
    x: -10,
    opacity: 0,
    transition: { duration: 0.4, ease: easings.easeOutCubic },
  },
  expanded: {
    x: 0,
    opacity: 1,
    transition: { duration: 0.4, delay: 0.2, ease: easings.easeOutCubic },
  },
};

function Tooltip({ icon, children, expanded }: TooltipProps) {
  return (
    <Pill>
      <Icon icon={icon} />
      <TextBoundary>
        <TextContainer
          variants={variants}
          animate={expanded ? "expanded" : "hidden"}
          transition={{ type: "tween" }}
        ></TextContainer>
        <TextInner
          variants={textVariants}
          animate={expanded ? "expanded" : "hidden"}
          transition={{ type: "tween" }}
        >
          {children}
        </TextInner>
      </TextBoundary>
    </Pill>
  );
}

export default Tooltip;
